import {
    SET_METADATA, UPDATE_METADATA, RESET_METADATA
} from '../constants'
import store from '../store'

export const setMetadata = metas => store.dispatch({ type: SET_METADATA, metas })
export const updateMetadata = metas => store.dispatch({ type: UPDATE_METADATA, metas })
export const resetMetadata = () => store.dispatch({ type: RESET_METADATA })
